<template>
   <button
      :class="`gts-btn gts-btn__${btnClassName} ${rounded ? 'rounded' : ''} ${modalTrigger ? 'modal-trigger-btn' : ''} ${notRounded ? 'not-rounded' : ''}`"
      v-if="!btnIsRouter"
      :disabled="isDisabled"
      @keypress.space.prevent
      @keypress.enter.prevent>
      <template v-if="!icon">
         <span class="g-radial-loader" v-if="isSpinnerActive"></span>
         <template v-else> {{ btnText }} {{ rounded }}</template>
      </template>
      <template v-else>
         <div class="lds-ring" v-if="isSpinnerActive">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
         </div>
         <template v-else>
            <span class="only-icon" :class="btnText ? 'with-text' : ''">
               <i :class="`gts-icon icon-${icon} ${modalTrigger ? 'modal-trigger-btn' : ''}`"></i>
               {{ btnText }}
            </span>
         </template>
      </template>
   </button>
   <router-link :to="btnRouterUrl" :class="`gts-btn gts-btn__${btnClassName}`" v-else>
      <template v-if="!icon">
         {{ btnText }}
      </template>
      <template v-else>
         <span class="only-icon" :class="btnText ? 'with-text' : ''">
            <i :class="`gts-icon icon-${icon} ${modalTrigger ? 'modal-trigger-btn' : ''}`"></i>
            <span class="text">{{ btnText }}</span>
         </span>
      </template>
   </router-link>
</template>

<script>
export default {
   name: "UIButton",
   props: {
      className: { String },
      text: { String },
      isRouter: { Boolean },
      routerUrl: [String, Object],
      icon: { String },
      rounded: { Boolean },
      notRounded: { Boolean },
      modalTrigger: { Boolean },
      isSpinnerActive: { Boolean },
      isDisabled: { Boolean },
   },
   data() {
      return {
         btnClassName: this.className,
         btnText: this.text,
         btnIsRouter: this.isRouter,
         btnRouterUrl: this.routerUrl,
      };
   },
   watch: {
      text: function (newValue) {
         var self = this;
         self.btnText = newValue;
      },
   },
};
</script>

<style lang="scss" scoped>
html body .gts-btn {
   display: flex;
   align-items: center;
   justify-content: center;

   max-width: 100%;
   height: 44px !important;
   padding: 0.5rem 2.5rem;
   background-color: transparent;
   border: 2px solid transparent;
   border-radius: 24rem;
   font-size: 16px;
   color: white;
   text-align: center;
   cursor: pointer;
   text-decoration: none;
   white-space: nowrap;
   transition: 0.3s all;

   &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
   }

   & > .lds-ring {
      & > div {
         width: 100%;
         height: 100%;
         margin: 0;
         border-width: 3px;
      }
   }

   & > .only-icon {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      i {
         filter: none !important;
      }
      .icon-white {
         filter: brightness(10);
      }

      &.with-text > i {
         margin-right: 8px;
      }
   }

   &__default {
      background-color: var(--primary);

      &:hover {
         background-color: var(--accent-primary);
      }

      &_outline {
         border-color: var(--primary);
         color: var(--primary);
         //background-color: var(--gray-50);
         background-color: var(--gray-0);

         &:hover {
            border-color: transparent !important;
            background-color: var(--accent-primary);
            color: white;
         }
      }
   }
   &__partialPay {
      background-color: var(--teal-600) !important;
      padding: 0 1rem !important;
      font-weight: 700 !important;
      .only-icon {
         i {
            height: 40px !important;
            width: 40px !important;
         }
      }
      &:hover {
         background-color: var(--teal-600);
      }
      &_outline {
         border-color: var(--primary);
         color: var(--primary);
         //background-color: var(--gray-50);
         background-color: var(--gray-0);
         &:hover {
            border-color: transparent !important;
            background-color: var(--accent-primary);
            color: white;
         }
      }
   }
   &__otp {
      background-color: transparent;

      &:hover {
         background-color: transparent;
      }

      &_outline {
         border-color: var(--primary);
         color: var(--primary);
         background-color: transparent;

         &:hover {
            border-color: transparent !important;
            background-color: var(--blue-400);
            color: transparent;
         }
      }
   }
   &__flight {
      background-color: var(--product-flight);

      &:hover {
         background-color: var(--accent-primary);
      }

      &_outline {
         border-color: var(--primary);
         color: var(--primary);
         //background-color: var(--gray-50);
         background-color: var(--gray-0);

         &:hover {
            border-color: transparent !important;
            background-color: var(--accent-primary);
            color: white;
         }
      }
   }

   &__hotel {
      background-color: var(--product-hotel);

      &:hover {
         background-color: var(--accent-primary);
      }

      &_outline {
         border-color: var(--primary);
         color: var(--primary);
         //background-color: var(--gray-50);
         background-color: var(--gray-0);

         &:hover {
            border-color: transparent !important;
            background-color: var(--accent-primary);
            color: white;
         }
      }
   }
   &__transfer-dark {
      background-color: var(--product-transfer-darken-10);

      &:hover {
         background-color: var(--product-transfer);
      }

      &_outline {
         border-color: var(--primary);
         color: var(--primary);
         //background-color: var(--gray-50);
         background-color: var(--gray-0);

         &:hover {
            border-color: transparent !important;
            background-color: var(--product-transfer);
            color: white;
         }
      }
   }
   &__transfer {
      background-color: var(--product-transfer);

      &:hover {
         background-color: var(--accent-primary);
      }

      &_outline {
         border-color: var(--primary);
         color: var(--primary);
         //background-color: var(--gray-50);
         background-color: var(--gray-0);

         &:hover {
            border-color: transparent !important;
            background-color: var(--accent-primary);
            color: white;
         }
      }
   }

   &__rentacar {
      background-color: var(--product-rentacar);

      &:hover {
         background-color: var(--accent-primary);
      }

      &_outline {
         border-color: var(--primary);
         color: var(--primary);
         //background-color: var(--gray-50);
         background-color: var(--gray-0);

         &:hover {
            border-color: transparent !important;
            background-color: var(--accent-primary);
            color: white;
         }
      }
   }

   &__light {
      background-color: var(--gray-0);
      border-color: var(--primary);
      color: var(--primary);

      &:hover {
         background-color: var(--primary);
         color: var(--gray-0);
      }

      &_outline {
         border-color: var(--primary);

         color: var(--primary);

         &:hover {
            background-color: var(--primary);
            color: white;
         }
      }
   }

   &__accent-primary {
      background-color: var(--accent-primary);
      color: white;

      &:hover {
         background-color: var(--accent-primary);
         color: white;
      }

      &_outline {
         border-color: var(--accent-primary);

         color: var(--accent-primary);

         &:hover {
            background-color: var(--accent-primary);
            color: white;
         }
      }
   }

   &__success {
      background-color: var(--cyan-400);

      &:hover {
         background-color: var(--cyan-400);
      }

      &_outline {
         border-color: var(--cyan-400);
         color: var(--cyan-400);

         &:hover {
            background-color: var(--cyan-400);
            color: white;
         }
      }
      &_dark_text {
         background-color: var(--cyan-400);
         color: var(--blue-700);
      }
   }

   &__info {
      background-color: var(--accent-primary);

      &:hover {
         background-color: var(--accent-primary);
      }

      &_outline {
         border-color: var(--accent-primary);
         color: var(--accent-primary);

         &:hover {
            background-color: var(--accent-primary);
            color: white;
         }
      }
   }
   &__confirm {
      background-color: var(--accent-primary);

      &:hover {
         background-color: var(--accent-primary);
      }

      &_outline {
         border-color: var(--accent-primary);
         color: var(--accent-primary);

         &:hover {
            background-color: var(--accent-primary);
            color: white;
         }
      }
   }
   &__priceChange {
      background-color: var(--cyan-400);

      &_outline {
         border-color: var(--cyan-400);
         color: var(--cyan-400);

         &:hover {
            background-color: var(--cyan-400);
            color: white;
         }
      }
   }

   &__alert {
      background-color: var(--orange-400);

      &:hover {
         background-color: var(--orange-400);
      }

      &_outline {
         border-color: var(--orange-400);
         color: var(--orange-400);

         &:hover {
            background-color: var(--orange-400);
            color: white;
         }
      }
   }
   &__grayscale {
      background-color: var(--gray-200);
      color: var(--gray-400);

      &:hover {
         background-color: var(--gray-200);
      }

      &_outline {
         border-color: var(--gray-200);
         color: var(--gray-200);

         &:hover {
            background-color: var(--orange-400);
            color: white;
         }
      }
   }

   &__warning {
      background-color: var(--red-500);

      &:hover {
         background-color: var(--red-500);
      }

      &_outline {
         border-color: var(--red-500);
         color: var(--red-500);

         &:hover {
            background-color: var(--red-500);
            color: white;
         }
      }
   }
   &__attention {
      background-color: var(--yellow-400);
      color: var(--gray-700);

      &:hover {
         background-color: var(--yellow-400);
      }

      &_outline {
         border-color: var(--yellow-400);
         color: var(--yellow-400);
         &:hover {
            background-color: var(--yellow-400);
            color: white;
         }
      }
   }

   &__purple {
      background-color: var(--purple-500);

      &:hover {
         background-color: var(--gray-0);
         color: var(--purple-500);
         transform: scale(1.1);
         border: 1px solid var(--purple-500);
      }

      &_outline {
         border-color: var(--purple-500);
         color: var(--purple-500);

         &:hover {
            background-color: var(--gray-0);
            color: var(--purple-500);
            border: 1px solid var(--purple-500);
            transform: scale(1.1);
         }
      }
   }
   &__pink {
      background-color: var(--purple-400);

      &:hover {
         background-color: var(--gray-0);
         color: var(--purple-500);
         transform: scale(1.1);
         border: 1px solid var(--purple-500);
      }

      &_outline {
         border-color: var(--purple-400);
         color: var(--purple-400);

         &:hover {
            background-color: var(--purple-400);
            color: var(--purple-500);
            border: 1px solid var(--purple-500);
            transform: scale(1.1);
         }
      }
   }
   &__gray {
      background-color: var(--gray-500);

      &:hover {
         color: var(--txt-invert);
         background-color: var(--gray-800);
      }

      &_outline {
         border-color: var(--gray-700);
         color: var(--gray-700);
         //background-color: var(--gray-50);
         background-color: var(--gray-0);

         &:hover {
            border-color: transparent !important;
            background-color: var(--gray-700);
            color: white;
         }
      }
   }
   &__dark-gray {
      background-color: var(--gray-700);

      &:hover {
         color: var(--txt-invert);
         background-color: var(--gray-800);
      }

      &_outline {
         border-color: var(--gray-700);
         color: var(--gray-700);
         //background-color: var(--gray-50);
         background-color: var(--gray-0);

         &:hover {
            border-color: transparent !important;
            background-color: var(--gray-700);
            color: white;
         }
      }
   }
   &.rounded {
      width: 40px;
      max-width: 40px;
      height: 40px;
      max-height: 40px;
      padding: 0;
      border-radius: 50% !important;
   }
   &.not-rounded {
      border-radius: 0.25rem;
   }
   &.gts-btn-animation {
      transform: scale(1);
      transition-property: transform;
      transition-timing-function: ease-in;
      transition-duration: 0.05s;

      &:hover {
         transform: scale(1.1);
      }
   }
}
</style>
